import { AppContextType } from 'marketplace-ui-common/types';
import { useGetAppReleaseHistoryQuery as useGetAppReleaseHistoryAppQuery } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc-app.hooks';
import { useGetAppReleaseHistoryQuery as useGetAppReleaseHistoryPublicQuery } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc.hooks';

interface UseAppReleaseHistoryProps {
  appContext: AppContextType;
  slug: string;
  skip?: boolean;
}

export function useAppReleaseHistory({
  appContext,
  slug,
  skip,
}: UseAppReleaseHistoryProps) {
  const isPublic = appContext === 'public';

  const { data: publicData } = useGetAppReleaseHistoryPublicQuery({
    variables: { slug },
    skip: !isPublic || skip,
  });

  const { data: appData } = useGetAppReleaseHistoryAppQuery({
    variables: { slug },
    skip: isPublic || skip,
  });

  return appData || publicData;
}
